// modal for confirming deletion of selected documents

import React from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useTheme } from 'emotion-theming';
import IcomoonReact from 'icomoon-react';

import NoHoverButton from '../../../../shared/components/NoHoverButton';
import Text from '../../../../shared/_TBComponents/Text';
import iconSet from '../../../../shared/images/teambuildr-selection.json';

const deleteItemText = {
  0: 'folder',
  1: 'file',
  2: 'link',
  3: 'items',
};

const ModalWrapper = styled('div')`
  display: flex;
  width: 100%;
`;

const NavigationWrapper = styled('div')`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  z-index: 1;
  .back-arrow-div {
    cursor: pointer;
  }
`;

const AnotherWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  margin-top: -40px;
`;

const TextWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 60%;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const ModalConfirmDelete = ({
  handleDeleteDocuments,
  selectedRows,
  currentUser,
  onRequestClose,
}) => {
  const groupDeleteDocuments = () => {
    const selectedRowsIds = selectedRows.map((row) => row.id);
    handleDeleteDocuments(currentUser.accountCode, selectedRowsIds);
  };
  const isDocumentDeleting = useSelector(
    (state) => state.documents.ui.isDocumentDeleting,
  );
  const theme = useTheme();

  const numItems = (Array.isArray(selectedRows) && selectedRows?.length) || 1;
  const deleteItemType = selectedRows.length > 1 ? 3 : selectedRows[0].type;
  const itemText = deleteItemText[deleteItemType];
  const modalMessage = `Are you sure you want to delete ${
    numItems === 1 ? 'this' : 'these'
  } ${itemText}?`;
  const folderWarning = 'Warning: All contents of the folder will be moved to the main directory.';
  const showFolderWarning = selectedRows.some((row) => row.type === 0);

  return (
    <ModalWrapper>
      <ModalWrapper>
        <AnotherWrapper>
          <NavigationWrapper>
            <Text className='back-arrow-div' onClick={onRequestClose}>
              <IcomoonReact iconSet={iconSet} size={10} icon='remove' />
            </Text>
          </NavigationWrapper>
          <TextWrapper>
            <Text
              fontWeight='600'
              fontSize={theme.textFontSizes[2]}
              style={{
                marginTop: '-15px',
              }}
            >
              {modalMessage}
            </Text>
            {showFolderWarning && (
              <Text
                styledTextProps={{
                  color: theme.colors.lightText[0],
                  fontSize: theme.textFontSizes[0],
                }}
              >
                {folderWarning}
              </Text>
            )}
          </TextWrapper>
        </AnotherWrapper>
        <NoHoverButton
          bottom
          fullWidth
          customColor='#f24540'
          cta={!isDocumentDeleting ? 'Delete' : 'Deleting...'}
          className='modal-button'
          disabled={isDocumentDeleting}
          large
          noBorder
          primary
          square
          onClick={() => groupDeleteDocuments()}
        />
      </ModalWrapper>
    </ModalWrapper>
  );
};

ModalConfirmDelete.propTypes = {
  handleDeleteDocuments: PropTypes.func.isRequired,
  selectedRows: PropTypes.instanceOf(Array).isRequired,
  currentUser: PropTypes.instanceOf(Object).isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default ModalConfirmDelete;
